import React, { useState } from 'react';
import { ShoppingCart, Heart, Star, Eye, ShoppingBag } from 'lucide-react';
import "../../styles/marketplace.css";

const ProductCard = ({ product, onAddToCart, onViewDetails, onViewProvider, selectedCurrency, rates, isWishlisted, onToggleWishlist }) => {
    // ... setup vars ...

    // ... (inside return) ...

    const { id, title, price, currency: baseCurrency, image, rating, reviews, providerName, providerId, stock } = product;
    const [imgError, setImgError] = useState(false);

    // Currency Conversion Logic
    const displayCurrency = selectedCurrency || baseCurrency;
    const rate = rates && rates[displayCurrency] ? rates[displayCurrency] : 1;
    const displayPrice = (price * rate).toFixed(2);

    // Helper to render stars
    const renderStars = () => {
        return [...Array(5)].map((_, i) => (
            <Star
                key={i}
                size={14}
                fill={i < Math.floor(rating) ? "currentColor" : "none"}
                className={`mp-star ${i < Math.floor(rating) ? 'filled' : ''}`}
            />
        ));
    };

    return (
        <div className="mp-product-card">
            {/* Image Container */}
            <div
                className="mp-card-image-container"
                onClick={() => onViewDetails(product)}
                style={{ cursor: 'pointer' }}
            >
                {imgError ? (
                    <div style={{
                        width: '100%',
                        height: '100%',
                        background: '#f3f4f6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#9ca3af',
                        fontSize: '14px'
                    }}>
                        <div style={{ textAlign: 'center' }}>
                            <ShoppingBag size={32} style={{ marginBottom: '8px', opacity: 0.5 }} />
                            <div>No Image</div>
                        </div>
                    </div>
                ) : (
                    <img
                        src={image}
                        alt={title}
                        className="mp-card-image"
                        onError={() => setImgError(true)}
                    />
                )}

                {/* Badges */}
                {stock === 0 ? (
                    <div className="mp-card-badge" style={{ background: '#EF4444' }}>
                        Out of Stock
                    </div>
                ) : stock < 5 ? (
                    <div className="mp-card-badge" style={{ background: '#F59E0B' }}>
                        Only {stock} left!
                    </div>
                ) : null}

                {/* Quick Actions Overlay */}
                <div className="mp-card-overlay">
                    <button
                        onClick={(e) => { e.stopPropagation(); onViewDetails(product); }}
                        className="mp-icon-btn"
                        title="Quick View"
                    >
                        <Eye size={18} />
                    </button>
                    <button
                        className="mp-icon-btn"
                        title={isWishlisted ? "Remove from Wishlist" : "Add to Wishlist"}
                        onClick={(e) => { e.stopPropagation(); onToggleWishlist(product); }}
                    >
                        <Heart size={18} fill={isWishlisted ? "#EF4444" : "none"} color={isWishlisted ? "#EF4444" : "currentColor"} />
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className="mp-card-content">
                <div className="mp-provider-name">
                    {providerName}
                </div>

                <h3 className="mp-product-title">
                    {title}
                </h3>

                <div className="mp-rating">
                    {renderStars()}
                    <span className="mp-reviews">({reviews})</span>
                </div>

                <div className="mp-card-footer">
                    <div className="mp-price">
                        <span className="mp-currency">{displayCurrency}</span>
                        {displayPrice}
                    </div>

                    <button
                        onClick={() => onAddToCart(product)}
                        disabled={stock === 0}
                        className="mp-add-btn"
                        style={{ opacity: stock === 0 ? 0.5 : 1, cursor: stock === 0 ? 'not-allowed' : 'pointer' }}
                    >
                        <ShoppingCart size={18} />
                        {stock === 0 ? 'Sold Out' : 'Add'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
